import React from "react";
import { useState, useEffect } from "react";
import { LogoTop } from "..";
import { useLocation, useNavigate } from "react-router-dom";

export function ErrorView() {

    const navigate = useNavigate();

    function handleClose(){
        navigate("/", {
            replace: true,
            
        });
    }

    return (
        <div>
            <div
                className="container"
                style={{
                    display:"flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    padding: "0px 24px"
                }}
            >
                <img
                    src={LogoTop}
                    alt=''
                    style={{
                        height: "100px",
                        display: "inline-block"
                    }}
                />
                <p
                    style={{
                        fontFamily: "SemiBold",
                        fontSize:"28px",
                        color: "#8B1B1A",
                        textAlign: "center !important",
                        marginTop: "20px"
                    }}
                >
                    Attenzione!
                </p>
                <p
                    style={{
                        fontFamily: "SemiBold",
                        textAlign: "center",
                        fontSize:"20px",
                        color: "#1C1C1A",
                        width: "140px",
                        marginTop: "52px"
                    }}
                >
                    Qualcosa è andato storto...
                </p>
                <p
                    style={{
                        fontFamily: "Regular",
                        textAlign: "center",
                        fontSize:"16px",
                        color: "#808080",
                        marginTop: "20px"
                    }}
                >
                    
                </p>
            </div>
            <div
                style={{
                    position: "fixed",
                    left: 0,
                    bottom: 46,
                    width: "100%",
                    textAlign: "center"
                }}
            >
                <p 
                    onClick={handleClose}
                    style={{
                        fontFamily: "SemiBold",
                        textAlign: "center",
                        fontSize:"18px",
                        color: "#808080",
                        textDecoration: "underline"
                    }}
                >
                    Chiudi
                </p>
            </div>
        </div>
    )
}